export class UserRoleAppModuleModel{


  Id:number;
  UserRoleId:string;
  ModuleId:number;
  UserRoleName:string;
  ModuleName:string;


}


